import { CONTROLS_SHOW, CONTROLS_HIDE } from '../actions/controls/constants';

const initialState = {
  show: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONTROLS_SHOW:
      return { ...state, show: action.payload };
    case CONTROLS_HIDE:
      return { ...state, show: action.payload };
    default:
      return state;
  }
};
